define('wamodal', ['jquery', 'waajax', 'wamessages'], function ($, waajax, wamessages) {

  var wamodal = {
    modalWrapper: $('.modal__wrapper'),
    modalBg: $('.js_modalBg'),
    modal: $('.js_modal'),
    modalContent: $('.js_modalContent'),
    loadingImg: '<div style="text-align:center"><img src="/skin/frontend/trenddeko-v40/default/images/loading.gif"></div>',
    viewClass: 'js_show',
    fadeTime: 500,
    backToElementID: "",
    body: $('body'),
    /*
      Arguments for waajax:
      content : string | url,
      data : data object for ajax request
      type:  string: "url",
      partial: class or id
      callback: function
     */

    open: function open(content, data, type, partial, callback) {

      var self = wamodal;

      self.loadMsg();

      if (arguments.length === 0) {
        self.modal.fadeIn(self.fadeTime);
      }

      type === "url" ? waajax.ajax(content, data, partial, callback) : self.modalContent.html(content);

      self.modal.show() && self.modalWrapper.animate({ right: 0 }) && self.body.css('overflowY', 'hidden');

      self.close();
    },
    close: function close(closeSelf, backToElementID) {
      this.closeCounter = 1;
      var self = wamodal;

      if (!!closeSelf) {
        $(self.modal).removeClass(self.viewClass).fadeOut(self.fadeTime, function () {
          self.modalContent.parent().attr('class', 'modal__wrapper');
          wamodal.modalContent.parent().removeClass('js_loadingHTML');
          wamodal.modalWrapper.removeAttr('id');
        }) && self.modalWrapper.animate({ right: '-100%' }) && self.body.css('overflowY', 'auto');
      }

      $('.js_modalClose, .js_modalBg').on('click', function (e) {
        e.stopImmediatePropagation();
        wamodal.close(true);
        if (wamodal.backToElementID !== "") {
          setTimeout(function () {
            wamodal.backToElement();
          }, self.fadeTime);
        }
      });

      this.partnerModal();
    },
    backToElement: function backToElement() {
      $('#' + wamodal.backToElementID).append(this.modalContent.children());
    },
    loadMsg: function loadMsg() {
      var self = wamodal;
      self.modalContent.html(self.loadingImg);
    },
    openSelf: function openSelf() {

      var dataModal = $('[data-modal]');
      if (dataModal.length > 0) {
        if (dataModal.data('modal') == 'open') {
          wamodal.open(dataModal.html());
          if (dataModal.data('backtoid')) {
            wamodal.backToElementID = dataModal.data('backtoid');
          }
        }
      }
    },
    partnerModal: function partnerModal() {
      var partnerModal = $('#js_trenddeko__link').closest('.modal');
      var partnerModalBG = partnerModal.find('.modal__background');
      var partnerModalClose = partnerModal.find('.js_modalClose');

      partnerModalClose.on('click', function () {
        try {
          ga('send', 'event', 'Popup', 'Click', 'Close Trenddeko Overlay');
        } catch (err) {}
      });

      if (partnerModalBG.length > 0) {
        partnerModalBG.unbind('click').css('cursor', 'auto');
      }
    },
    openUrl: function openUrl() {

      $('body').on('click', '[data-modal-url]', function (e) {
        e.preventDefault();

        wamodal.modalContent.parent().addClass('js_loadingHTML');

        var _this = $(this);

        wamodal.open();

        waajax.ajax(_this.data('modal-url'), _this.data('modal-data'), _this.data('modal-partial'), function (content) {
          wamodal.open(content);
        });

        wamodal.fnc(_this, _this);
      });
    },
    openBtns: function openBtns() {

      function modalBtnClick(el) {
        var _this = el;
        var element = $('#' + _this.data('modal-open') + ' > div');
        var elementID = $('#' + _this.data('modal-open')).attr('id');

        if (elementID !== 'undefined') {
          wamodal.backToElementID = elementID;
        }

        if (_this.attr('data-obj')) {
          var jsMsg = _this.data('obj')['js_message'] || "";
          if (jsMsg.length > 0) element.find('.js_message').html(wamessages[wamessages.actLang][jsMsg]);
        }

        $('.modal__wrapper').addClass(_this.data('modal-open'));

        wamodal.open(element);
        wamodal.close(false, elementID);
        wamodal.fnc(_this, _this);
      }

      $('body').on('click', '[data-modal-open]', function (e) {
        e.preventDefault();
        modalBtnClick($(this));
      });
    },
    energyLabelModal: function energyLabelModal() {
      $('.ifellabel--detail').on('click', function () {
        $('#js_energylabel').click();
      });

      if ('ifellabelModal' in sessionStorage) {
        $('#js_energylabel').click();
        sessionStorage.removeItem('ifellabelModal');
      }
    },
    showImage: function showImage(img) {
      this.open('<img src="' + img.attr('src') + '" alt="">');
    },
    fnc: function fnc(el, params) {

      if (typeof el.data('fnc') !== 'undefined') {
        var fnstring = el.data('fnc');
        var fnparams = params;
        var fn = window[fnstring];
        if (typeof fn === "function") fn.apply(null, fnparams);
      } else {
        return;
      }
    }
  };

  window.wamodal = wamodal;

  return wamodal;
});

